<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    buttonText: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    id: Math.random().toString(32).substring(2),
    isOpen: false,
  }),
  computed: {
    readMore() {
      return this.buttonText || this.$t('buttons.read_more');
    },
  },
};
</script>

<template>
  <component :is="tag" :id="`#read-more-${id}`">
    <slot name="intro" />
    <p v-show="!isOpen" class="has-text-right pt-2 tdecoration-underline">
      <a :href="`#read-more-${id}`" @click.prevent="isOpen = true">
        {{ readMore }}
      </a>
    </p>
    <slot v-if="isOpen" />
  </component>
</template>
